import {useState} from 'react';
import {isValidToken, validatePassword, MAX_PASSWORD_LENGTH} from '../validation';

export default function ResetPasswordScreen() {
    const params = new URLSearchParams(window.location.search);
    const rawToken = params.get('token') || '';
    const token = isValidToken(rawToken) ? rawToken : '';
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        if (!token) {
            setError('Invalid or missing reset token.');
            return;
        }
        const pwError = validatePassword(password);
        if (pwError) {
            setError(pwError);
            return;
        }
        if (password !== confirm) {
            setError('Passwords do not match.');
            return;
        }
        setSubmitting(true);
        try {
            const res = await fetch('/api/v1/auth/reset-password', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({token, password}),
            });
            if (!res.ok) {
                const data = await res.json();
                setError(data.error || 'Reset failed. Please try again.');
                return;
            }
            window.location.href = '/?signin&reset=success';
        } catch {
            setError('Reset failed. Please try again.');
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div className="login-screen">
            <form className="login-form" onSubmit={handleSubmit}>
                <h2 className="login-title">Reset password</h2>
                {error ? <p className="login-error">{error}</p> : null}
                <input
                    className="login-input"
                    type="password"
                    placeholder="New password"
                    value={password}
                    maxLength={MAX_PASSWORD_LENGTH}
                    onChange={e => setPassword(e.target.value)}
                    autoFocus
                />
                <input
                    className="login-input"
                    type="password"
                    placeholder="Confirm new password"
                    value={confirm}
                    maxLength={MAX_PASSWORD_LENGTH}
                    onChange={e => setConfirm(e.target.value)}
                />
                <button
                    className="login-button"
                    type="submit"
                    disabled={!password || !confirm || submitting}
                >{submitting ? 'Resetting...' : 'Set new password'}</button>
                <p className="login-register-link">
                    <a href="/?signin">Back to sign in</a>
                </p>
            </form>
        </div>
    );
}
